import React from 'react';
import { Link } from 'react-router-dom';
import AJHMLogo from './AJHMLogo';
import { FaEnvelope, FaGlobe, FaPhone } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-[#0A2239] text-white pt-16 pb-10 border-t-4 border-[#03478E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 pb-12 border-b border-white/10">

          {/* Column 1 - Brand Logo & Mission */}
          <div className="lg:col-span-1 space-y-4">
            <Link to="/" className="inline-block">
              <AJHMLogo isDark={true} height={88} />
            </Link>
            <p className="text-gray-300 text-sm leading-relaxed">
              A Peer-Reviewed Journal of Homoeopathic Medicine and Related Healthcare Research
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div className="space-y-3">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-blue-200">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/" className="hover:text-white transition">Home</Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-white transition">About</Link>
              </li>
              <li>
                <Link to="/aims-and-scope" className="hover:text-white transition">Aims & Scope</Link>
              </li>
              <li>
                <Link to="/editorial-board" className="hover:text-white transition">Editorial Board</Link>
              </li>
              <li>
                {/* <Link to="/archives" className="hover:text-white transition">Archives</Link> */}
              </li>
            </ul>
          </div>

          {/* Column 3 - For Authors */}
          <div className="space-y-3">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-blue-200">
              For Authors
            </h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/information-for-authors" className="hover:text-white transition">Author Guidelines</Link>
              </li>
              <li>
                <Link to="/submission-guidelines" className="hover:text-white transition">Peer Review</Link>
              </li>
              <li>
                <Link to="/submission-guidelines" className="hover:text-white transition">Publication Ethics</Link>
              </li>
              <li>
                <Link to="/article-processing-charge" className="hover:text-white transition">Article processing Charges (APC)</Link>
              </li>
              <li>
                {/* <Link to="/contact" className="hover:text-white transition">Contact</Link> */}
              </li>
            </ul>
          </div>

          {/* Column 4 - Publisher Information */}
          <div className="space-y-3">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-blue-200">
              Publisher
            </h4>
            <div className="text-sm text-gray-300 space-y-2 leading-relaxed">
              <p className="font-semibold text-white">DOMUS Publications</p>
              <p className="text-xs text-gray-400">A publishing imprint of Domus Mediverse Private Limited</p>
              <p className="font-semibold text-white pt-1">Dr Dheeraj Pandey</p>
              <div className="flex items-start gap-2 text-xs">
                {/* <FaMapMarkerAlt className="text-blue-400 mt-0.5 flex-shrink-0" /> */}
                <span>
                  Hill View Colony, Near Chandra Vatika, Khatima, Udham Singh Nagar - 262308, Uttarakhand, India
                </span>
              </div>
            </div>
          </div>

          {/* Column 5 - Contact */}
          <div className="space-y-3">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-blue-200">
              Contact
            </h4>
            <div className="space-y-2 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <FaEnvelope className="text-blue-400 flex-shrink-0" />
                <a href="mailto:editor@aimjhm.com" className="hover:text-white transition">
                  editor@aimjhm.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FaEnvelope className="text-blue-400 flex-shrink-0" />
                <a href="mailto:admin@domusmediverse.com" className="hover:text-white transition">
                  admin@domusmediverse.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FaEnvelope className="text-blue-400 flex-shrink-0" />
                <a href="mailto:domus.publications@gmail.com" className="hover:text-white transition break-all">
                  domus.publications@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FaGlobe className="text-blue-400 flex-shrink-0" />
                <a href="https://aimjhm.com" className="hover:text-white transition">
                  aimjhm.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FaGlobe className="text-blue-400 flex-shrink-0" />
                <a href="https://domusmediverse.com" className="hover:text-white transition">
                  domusmediverse.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <FaPhone className="text-blue-400 flex-shrink-0" />
                <a href="tel:+919927042135" className="hover:text-white transition">
                  +91 9927042135
                </a>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-400">
          <div>
            &copy; {new Date().getFullYear()} AIM Journal of Homoeopathic Medicine. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link to="/privacy-policy" className="hover:text-white transition">Privacy Policy</Link>
            <span>|</span>
            <Link to="/copyright" className="hover:text-white transition">Copyright Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
